export default "__VITE_ASSET__DY_LU_2X__"